import KitFadeView from '@omni/kit/components/KitFadeView';
import KitIcon from '@omni/kit/components/KitIcon';
import KitText from '@omni/kit/components/KitText';
import BorderRadius from '@omni/kit/theming/BorderRadius';
import Colors from '@omni/kit/theming/Colors';
import Spacing from '@omni/kit/theming/Spacing';
import formatDuration from '@omni/kit/utilities/formatDuration';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';

import ButtonTouchable from './ButtonTouchable';

export interface PlayPauseControlProps {
  isVisible?: boolean;
  onPlay?: () => void;
  onResume?: () => void;
  progress?: number;
}

export default function ResumePlayControl({
  isVisible,
  onPlay,
  onResume,
  progress = 0,
}: PlayPauseControlProps): ReactElement {
  const { t } = useTranslation(['media']);
  const progressText = progress >= 0 ? formatDuration(progress) : '';

  return (
    <KitFadeView show={isVisible} keepElementSize>
      <ButtonTouchable
        onPress={onResume}
        style={{ borderRadius: 27, marginBottom: Spacing.m }}
      >
        <View style={[styles.resumeAndPlayButton]}>
          <KitIcon color={Colors.N0} name='play-circle' size={14} />
          <KitText semiBold white style={styles.text}>
            {t('resumeFrom', { duration: progressText })}
          </KitText>
        </View>
      </ButtonTouchable>
      <ButtonTouchable onPress={onPlay} style={{ borderRadius: 27 }}>
        <View style={styles.resumeAndPlayButton}>
          <KitIcon color={Colors.N0} name='resume' size={14} />
          <KitText semiBold white style={styles.text}>
            {t('playFromBeginning')}
          </KitText>
        </View>
      </ButtonTouchable>
    </KitFadeView>
  );
}

const styles = StyleSheet.create({
  playButtonWrapper: {
    alignItems: 'center',
    height: '100%',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '100%',
  },
  resumeAndPlayButton: {
    alignItems: 'center',
    backgroundColor: '#000000dd',
    borderRadius: BorderRadius.full,
    color: Colors.N0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    paddingHorizontal: Spacing.xl,
    paddingVertical: Spacing.m,
    minWidth: 229,
  },
  text: {
    marginLeft: 10,
  },
});
